import { FC } from 'react';
import { Col, Row } from 'react-grid-system';
import { useUserLanguage } from '@/customHooks';
import styled from 'styled-components';
import textsData from '@/textData/CreateIncidentTexts.json'
import {
  CreateIncidentConfirmationDialog,
  SelectIncidentCategoryMenu,
  SelectIncidentEvidenceForm,
  SelectIncidentPriorityMenu,
  SelectIncidentPropertyMenu,
  SelectIncidentTypeMenu,
} from '../organism';

type CreateIncidentTemplateProps = {
  currentTemplate: number
}

const TextContainer = styled(Col)`
  text-align: center;
  margin-bottom: 3rem;
`

export const CreateIncidentTemplate: FC<CreateIncidentTemplateProps> = ({ currentTemplate }) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <>
      <Row>
        <TextContainer>
          <h1>{texts.templateText[currentTemplate].title}</h1>
          <p>{texts.templateText[currentTemplate].description}</p>
        </TextContainer>
      </Row>
      {
        (() => {
          switch(currentTemplate) {
            case 0:
              return <SelectIncidentPropertyMenu />
            
            case 1:
              return <SelectIncidentTypeMenu />

            case 2:
              return <SelectIncidentCategoryMenu />

            case 3:
              return <SelectIncidentPriorityMenu />

            case 4:
              return <SelectIncidentEvidenceForm />

            case 5:
              return <CreateIncidentConfirmationDialog />

            default:
              throw new Error('Invalid Current template [CreatePropertyTemplate]')
          }
        })()
      }
    </>
  )
}
